module.exports = __webpack_public_path__ + "media/images/home/procedures-41273dfa64264ca3acbb4e9c5ca7bee4.png";